import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {CreateListComponent} from './create-list.component';
import {TranslateModule} from "@ngx-translate/core";
import {ReactiveFormsModule} from "@angular/forms";
import {FormFieldModule} from "@app/presentation/components/form-field/form-field.module";
import {AppBarModule} from "@app/presentation/components/app-bar/app-bar.module";
import {ButtonModule} from "@app/presentation/components/button/button.module";


@NgModule({
  declarations: [
    CreateListComponent
  ],
    imports: [
        CommonModule,
        TranslateModule,
        ReactiveFormsModule,
        FormFieldModule,
        AppBarModule,
        ButtonModule
    ],
  exports: [
    CreateListComponent
  ]
})
export class CreateListModule { }
